import { getLocationsAddressesListQueryOptions, type ForManagerLocationDetail } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: Pick<ForManagerLocationDetail, "id"> };

export const addressesQuery = ({ location }: QueriesInput) =>
  getLocationsAddressesListQueryOptions(location.id, undefined, { query: { staleTime: Number.POSITIVE_INFINITY } });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [addressesQuery(input)];
